import React from "react";
import { Refund } from "../features";
import { Grid } from "@material-ui/core";

function RefundPage() {
  return (
    <>
      <Refund.Container />
    </>
  );
}

export default RefundPage;
